import ScreenCreditList from 'screens/Credit/List';
import { CREDIT } from 'routes/paths';

const creditRoutes = [
  {
    path: CREDIT.LIST,
    name: 'CreditList',
    component: ScreenCreditList,
    loginRequired: true,
    allowPermissions: [
      'list_credittransaction',
      'list_ownership_credittransaction',
    ],
  },
];

export default creditRoutes;
